import React from "react";

const PontDiv = ({t}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="480"
      height="320"
      x="0"
      y="0"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 480 320"
    >
      <defs>
        <g id="a">
          <path
            fill="#333"
            d="M179.2 22.4q0-1.1-.55-1.95h-3.1 3.1q-.2-.25-.45-.5-1-1-2.4-1-1.45 0-2.45 1-1 1-1 2.45 0 1.4 1 2.4 1 1.05 2.45 1.05 1.4 0 2.4-1.05.8-.75 1-1.75v-.65m0 255.95q-.25-1-1-1.75-1-1-2.4-1-1.45 0-2.45 1-1 1-1 2.4 0 1.45 1 2.45 1 1 2.45 1 1.4 0 2.4-1t1-2.45v-.65m143.75-1.75q-1-1-2.45-1-1.4 0-2.4 1-.75.75-.95 1.75-.1.3-.1.65 0 1.45 1.05 2.45 1 1 2.4 1 1.45 0 2.45-1 1-1 1-2.45 0-1.4-1-2.4m-72.35 1.75q-.2-1-.95-1.75-1-1-2.4-1-.6 0-1.15.15-.7.25-1.3.85-.75.75-.9 1.75-.1.3-.1.65 0 1.45 1 2.45.877.877 2.1.95.172.05.35.05 1.4 0 2.4-1t1-2.45q0-.35-.05-.65m-3.35-130.55q-.4 0-.7.1-.95.15-1.75.9-1 1.05-1 2.45 0 1.4 1 2.45.75.7 1.75.95.3.05.7.05 1.4 0 2.4-1 1-1.05 1-2.45 0-.35-.05-.7-.2-1-.95-1.75-1-1-2.4-1m75.7.55q-1-1-2.45-1-1.4 0-2.4 1-.95.95-1.05 2.2v.25q0 1.4 1.05 2.4 1 1.05 2.4 1.05 1.45 0 2.45-1.05 1-1 1-2.4 0-1.45-1-2.45z"
          ></path>
          <path
            fill="#999"
            d="M257.55 190.4H237.85v51.75h19.7V190.4m0-128.25h-19.7v51.75h19.7V62.15z"
          ></path>
        </g>
        <path
          id="b"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M247.05 22.45H179.2m-.55-2h-3.1M246.9 288.4v-5.975m-2.6 15.225h6m-10.55-6h15m-12.7 3h10.5m-15.05-6H257"
        ></path>
        <path
          id="c"
          fill="none"
          stroke="#333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M247 23.25l-.1 25.65m-.2 65l-.15 34q.3-.1.7-.1 1.4 0 2.4 1 .75.75.95 1.75h66.45q.1-1.25 1.05-2.2 1-1 2.4-1 1.45 0 2.45 1 1 1 1 2.45 0 1.4-1 2.4-1 1.05-2.45 1.05-1.4 0-2.4-1.05-1.05-1-1.05-2.4v-.25M246.9 48.9l-.05 13.25m-67.65-39.7v.6q-.2 1-1 1.75-1 1.05-2.4 1.05-1.45 0-2.45-1.05-1-1-1-2.4 0-1.45 1-2.45 1-1 2.45-1 1.4 0 2.4 1 .25.25.45.5.55.85.55 1.95v.05zm67.35 132.2q-1-.25-1.75-.95-1-1.05-1-2.45 0-1.4 1-2.45.8-.75 1.75-.9m4.05 2.65q.05.35.05.7 0 1.4-1 2.45-1 1-2.4 1-.4 0-.7-.05l-.15 35.75m-.2 51.75l-.1 33.6q.55-.15 1.15-.15 1.4 0 2.4 1 .75.75.95 1.75h66.55q.2-1 .95-1.75 1-1 2.4-1 1.45 0 2.45 1 1 1 1 2.4 0 1.45-1 2.45-1 1-2.45 1-1.4 0-2.4-1-1.05-1-1.05-2.45 0-.35.1-.65m-73.25 0q.15-1 .9-1.75.6-.6 1.3-.85m.8 6.675q-1.223-.098-2.1-.975-1-1-1-2.45 0-.35.1-.65h-64.7v.65q0 1.45-1 2.45-1 1-2.4 1-1.45 0-2.45-1-1-1-1-2.45 0-1.4 1-2.4t2.45-1q1.4 0 2.4 1 .75.75 1 1.75m71.4 0q.05.3.05.65 0 1.45-1 2.45-1 1-2.4 1-.178 0-.35-.025m-304-102.075l-5.95-55.45"
        ></path>
        <path
          id="d"
          fill="none"
          stroke="#333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M336.1 273.55V154l-7.35 7.3m14.6 0l-7.25-7.3M173.2 48.85l-7.25-7.3V263.2m0-221.65l-7.35 7.35"
        ></path>
        <path
          id="e"
          fill="none"
          stroke="#333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M246.85 62.15h10.7v51.75H246.7m.15-51.75h-9v51.75h8.85m-.3 76.5h11.15v51.75h-19.7V190.4h8.55z"
        ></path>
        <path
          id="f"
          fill="none"
          stroke="#F60"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M254.25 41.55l-7.35 7.35-7.25-7.3"
        ></path>
      </defs>
      <use xlinkHref="#a"></use>
      <use xlinkHref="#b"></use>
      <use xlinkHref="#c"></use>
      <use xlinkHref="#d"></use>
      <use xlinkHref="#e"></use>
      <use xlinkHref="#f"></use>
      <g transform="matrix(.91594 0 0 .91594 45 129.85)">
        <clipPath id="g">
          <path fill="#FFF" d="M-2 -2H108V42.9H-2z"></path>
        </clipPath>
        <text clip-path="url(#g)" writingMode="lr">
          <tspan
            x="17.85"
            y="16.1"
            fill="#F60"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >
            {t("tension1")}
          </tspan>
          <tspan
            x="9.55"
            y="37.55"
            fill="#F60"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >
            {t("entree")}
          </tspan>
        </text>
      </g>
      <g transform="matrix(.91594 0 0 .91594 347.25 203.1)">
        <clipPath id="h">
          <path fill="#FFF" d="M-2 -2H108V42.9H-2z"></path>
        </clipPath>
        <text clip-path="url(#h)" writingMode="lr">
          <tspan
            x="17.85"
            y="16.1"
            fill="#F60"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >
            {t("tension2")}
          </tspan>
          <tspan
            x="13.5"
            y="37.55"
            fill="#F60"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >
            {t("sortie")}
          </tspan>
        </text>
      </g>
      <g transform="matrix(.91594 0 0 .91594 264.4 71.2)">
        <clipPath id="i">
          <path fill="#FFF" d="M-7.5 -2H38.5V36.05H-7.5z"></path>
        </clipPath>
        <text clip-path="url(#i)" writingMode="lr">
          <tspan
            x="-5.4"
            y="28.15"
            fill="#F60"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="28"
            fontWeight="bold"
          >
            R2
          </tspan>
        </text>
      </g>
      <g transform="matrix(.91594 0 0 .91594 264.4 199.45)">
        <clipPath id="j">
          <path fill="#FFF" d="M-7.5 -2H38.5V36.05H-7.5z"></path>
        </clipPath>
        <text clip-path="url(#j)" writingMode="lr">
          <tspan
            x="-5.4"
            y="28.15"
            fill="#F60"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="28"
            fontWeight="bold"
          >
            R1
          </tspan>
        </text>
      </g>
      <g transform="matrix(.91594 0 0 .91594 252.05 25.05)">
        <clipPath id="k">
          <path fill="#FFF" d="M3.85 -2H17.55V36.05H3.85z"></path>
        </clipPath>
        <text clip-path="url(#k)" writingMode="lr">
          <tspan
            x="5.9"
            y="28.15"
            fill="#F60"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="28"
            fontWeight="bold"
          >
            i
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export default PontDiv;
